import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
export function FinalCloseSection() {
  return <SectionWrapper id="cierre" withGlow data-id="element-121">
      <div className="max-w-3xl mx-auto text-center" data-id="element-122">
        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-[#e8e6e1] mb-8 leading-tight" data-id="element-123">
          Tu identidad actual fue creada por{' '}
          <span className="text-gold-gradient" data-id="element-124">repetición.</span>
          <br data-id="element-125" />
          Tu nueva identidad comienza con{' '}
          <span className="italic" data-id="element-126">una decisión.</span>
        </h2>

        <p className="text-lg md:text-xl text-[#9a9aab] leading-relaxed mb-6 max-w-2xl mx-auto" data-id="element-127">
          Cada día que pasa sin tomar acción, tu subconsciente refuerza los
          mismos patrones. La misma procrastinación. El mismo autosabotaje. La
          misma frustración.
        </p>

        <p className="text-lg md:text-xl text-[#e8e6e1] leading-relaxed mb-12 max-w-2xl mx-auto font-medium" data-id="element-128">
          Pero hoy puedes elegir diferente. Hoy puedes decidir que la versión de
          ti que has sido hasta ahora{' '}
          <span className="text-[#c9a84c]" data-id="element-129">no es la versión final.</span>
        </p>

        <div className="bg-gradient-to-b from-[#16213e] to-[#1a1a2e] border-2 border-[#c9a84c]/30 rounded-2xl p-8 md:p-12 mb-8" data-id="element-130">
          <p className="text-[#c9a84c] text-sm uppercase tracking-[0.2em] mb-6 font-semibold" data-id="element-131">
            Sistema NEXUS™
          </p>

          <a href="https://pay.hotmart.com/L104469229P?bid=1772161592044" target="_blank" rel="noopener noreferrer" onClick={() => {
          const f = window as any;
          if (f.fbq) f.fbq('track', 'InitiateCheckout');
          setTimeout(() => {
            window.location.href = 'https://pay.hotmart.com/L104469229P?bid=1772161592044';
          }, 500);
        }} className="inline-flex items-center justify-center gap-3 px-12 py-6 text-xl
              font-semibold tracking-wide text-[#1a1a2e]
              bg-gradient-to-r from-[#c9a84c] via-[#f0d060] to-[#c9a84c] bg-[length:200%_auto]
              rounded-lg cta-pulse
              transition-all duration-500 ease-out
              hover:bg-[position:right_center] hover:scale-[1.03] hover:shadow-[0_0_50px_rgba(201,168,76,0.5)]
              active:scale-[0.98]
              focus:outline-none focus:ring-2 focus:ring-[#f0d060] focus:ring-offset-2 focus:ring-offset-[#1a1a2e]
              cursor-pointer" style={{
          textDecoration: 'none'
        }} data-id="element-132">
            ⭐ Comenzar Mi Transformación Ahora ⭐
          </a>

          <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4 text-[#6b6b7b] text-sm" data-id="element-133">
            <span data-id="element-134">✓ Acceso inmediato</span>
            <span className="hidden sm:inline" data-id="element-135">·</span>
            <span data-id="element-136">✓ Pago único</span>
            <span className="hidden sm:inline" data-id="element-137">·</span>
            <span data-id="element-138">✓ Garantía 21 días</span>
          </div>
        </div>

        <p className="text-[#6b6b7b] text-sm italic" data-id="element-139">
          "El mejor momento para plantar un árbol fue hace 20 años. El segundo
          mejor momento es ahora."
        </p>
      </div>
    </SectionWrapper>;
}